<template>
  <div class="w-100">
    <div class="main-container-revision my-1 w-100">
      <deal-header-chat
        v-if="chat_deal"
        :title="chat_deal.title"
        :price="chat_deal.price"
        :is_danger="true"
      />
      <div class="revision-request">
        <feather-icon
          v-if="!chat_deal"
          icon="EditIcon"
          class="float-right-icon-revision"
        />
        <p class="revision-label mb-1">
          {{ $t("chat.changesRequired") }}:
        </p>

        <p class="revision-message mb-2">
          {{ message.message }}
        </p>

        <p
          class="revision-remaining m-0"
          v-if="!chat.casting_call"
        >
          {{ revisions_remaining }}
          {{ $t("creator.revisionRemaining") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getFormatTimeDifferenceChat } from "@/libs/utils/times";
import { verifyAsset } from "@/libs/utils/urls";
import { decimalFixed } from "@/libs/utils/formats";

export default {
  name: "revisionChat",

  components: {
    DealHeaderChat: () => import('@/views/pages/proposals/chat/dealHeaderChat.vue'),
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    chat: {
      type: Object,
      required: true,
    },
  },
  computed: {
    brand() {
      return this.chat?.brand || {};
    },

    chat_deal() {
      return this.message?.chat_deals?.deal || null;
    },

    revisions_remaining() {
      return this.chat?.is_legacy === false ? this.message?.chat_deals?.revisions_remaining : this.chat?.revisions_remaining;
    },
  },

  data() {
    return {
      verifyAsset,
      getFormatTimeDifferenceChat,
      decimalFixed,
    };
  },
};
</script>

<style>
.date-chat-revision {
  font-family: "avenir-light";
  font-size: 11px;
  margin-left: 0.5em;
  color: #808080;
}

.main-container-revision {
  position: relative;
  border-radius: 1em;
  border: 1px solid #ccccccb0;
  overflow: hidden;
}

.float-right-icon-revision {
  position: absolute;
  right: 1em;
  top: 1em;
}

.revision-request {
  background: #fff4f4;
  border: 1px solid #ffd6d6;
  border-radius: 0 0 10px 10px;
  padding: 12px 14px;
}

.revision-label {
  font-size: 13px;
  font-weight: 600;
  color: #dc3545;
}

.revision-message {
  font-size: 14px;
  color: #212529;
  line-height: 1.4;
  white-space: pre-line;
}

.revision-remaining {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
}
</style>